import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  type PopoverOrigin,
} from '@mui/material';
import { ExitToApp, Logout, Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { useToastr } from '@farmshare/ui-components';
import { useCognitoAuth } from '../../auth/cognito-auth-context';

interface ProfileMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onLogout: () => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

export function ProfileMenu({
  anchorEl,
  onClose,
  onLogout,
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'bottom', horizontal: 'left' },
}: ProfileMenuProps) {
  const navigate = useNavigate();
  const { impersonateUserId, clearImpersonation } = useCognitoAuth();
  const { push: pushToast } = useToastr();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{ paper: { sx: { ml: 1, borderRadius: 2 } } }}
    >
      <MenuList dense>
        <MenuItem
          onClick={() => {
            onClose();
            navigate('/profile');
          }}
        >
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          <ListItemText>Profile</ListItemText>
        </MenuItem>
        {impersonateUserId && (
          <MenuItem
            onClick={() => {
              onClose();
              clearImpersonation();
              pushToast({
                title: 'Stopped impersonating user',
                body: 'You are now back to your admin account',
                bg: 'info',
              });
              window.location.reload();
            }}
          >
            <ListItemIcon>
              <ExitToApp fontSize="small" />
            </ListItemIcon>
            <ListItemText>Stop Impersonating</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            onClose();
            onLogout();
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </MenuList>
    </Popover>
  );
}
